import React, { useState } from "react";
import {
  Typography,
  Button,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Box } from "@mui/system";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { issueCommandThunk } from "../features/aircraft/aircraftSlice";
import {
  selectCommand,
  selectSelectedUavDirect,
  selectSelectedUavId,
  selectFlightModeById,
} from "../features/aircraft/aircraftSelectors";
import { Command } from "../features/aircraft/types";
import { AircraftNub } from "./AircraftNub";
import { ReactComponent as ForwardArrow } from "../assets/svg/ForwardArrow.svg";
import { ReactComponent as Close } from "../assets/svg/Close.svg";
import { selectRequestById } from "../features/session/sessionSlice";
const srtlIcon = require("../assets/svg/SmartRTL.png");
const rtlIcon = require("../assets/svg/RTL.png");
const landIcon = require("../assets/svg/Land.png");
const pauseIcon = require("../assets/svg/Pause.png");
const deliverIcon = require("../assets/svg/Deliver.png");
const chuteIcon = require("../assets/svg/CHUTE.png");
const closeIcon = require("../assets/svg/close2.png");

// COMMAND_SMARTRTL
// COMMAND_RTL
// COMMAND_LAND
// COMMAND_PAUSE
// COMMAND_DELIVER

export const commandState: {
  [key in Command]: {
    description: string;
    newFlightMode: string;
    newUavState: string;
    action: string;
    icon: any;
  };
} = {
  COMMAND_ARM: {
    description: "This will arm the aircraft and start the flying mission.",
    newFlightMode: "AUTO",
    newUavState: "MISSION",
    action: "Start Mission",
    icon: srtlIcon,
  },
  COMMAND_SMARTRTL: {
    description: "All Aircraft will return home by retracing a safe path.",

    action: "Slide To SRTL",
    newFlightMode: "CMODE(27)",
    newUavState: "",
    icon: srtlIcon,
  },
  COMMAND_ABORT: {
    description: "All Aircraft will abort",

    action: "Slide To ABORT",
    newFlightMode: "CMODE(27)",
    newUavState: "",
    icon: srtlIcon,
  },
  COMMAND_RTL: {
    description: "The aircraft will land at the nearest rally point.",

    action: "Slide To Rally",
    newFlightMode: "CMODE(27)",
    newUavState: "",
    icon: rtlIcon,
  },
  COMMAND_LAND: {
    description: "This will cause the aircraft to land immediately.",

    action: "Slide To Land",
    newFlightMode: "CMODE(27)",
    newUavState: "",
    icon: landIcon,
  },
  COMMAND_RESUME: {
    description: "This will cause the aircraft to resume mission.",
    newFlightMode: "AUTO",
    newUavState: "MISSION",
    action: "Resume mission.",
    icon: landIcon,
  },
  COMMAND_PAUSE: {
    description: "This will cause the aircraft to pause flight.",
    action: "Slide To Pause",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    icon: pauseIcon,
  },
  COMMAND_PARACHUTE: {
    description:
      "This will cause the aircraft to kill motors and deploy parachute.",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    action: "!!! DEPLOY CHUTE !!!",
    icon: chuteIcon,
  },
  COMMAND_ALT_NOGPS: {
    description: "COMMAND_ALT_NOGPS",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    action: "COMMAND_ALT_NOGPS",
    icon: pauseIcon,
  },
  COMMAND_DISSARM: {
    description: "This will cause the aircraft to kill motors!",
    newFlightMode: "CMODE(27)",
    newUavState: "MISSION",
    action: "Kill motors!",
    icon: pauseIcon,
  },
  COMMAND_DROP: {
    description: "This will cause the aircraft to initiate a test drop.",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    action: "Test drop",
    icon: pauseIcon,
  },
  COMMAND_CANCEL: {
    description: "This will cancel the loaded mission.",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    action: "Cancel takeoff",
    icon: pauseIcon,
  },
  COMMAND_DELIVER: {
    description: "This will start the drop process.",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    action: "Initiate drop",
    icon: deliverIcon,
  },
  COMMAND_AUTO_ARM: {
    description: "All aircraft will disable auto arm.",
    newFlightMode: "POSHOLD",
    newUavState: "MISSION",
    action: "Slide to Disable Auto Arm",
    icon: closeIcon,
  },
};

export const ConfirmCommand = (props: { close: () => void }) => {
  const dispatch = useAppDispatch();
  const selectedUavId = useAppSelector(selectSelectedUavId);
  const selectedUavDirect = useAppSelector(selectSelectedUavDirect);
  const command = useAppSelector(selectCommand);
  const [commandRequest, setCommandRequest] = useState<string>("");

  const commandRequestPending = useAppSelector((state) =>
    selectRequestById(state, commandRequest)
  );
  const flightMode = useAppSelector((state) =>
    selectFlightModeById(state, selectedUavId)
  );

  const close = () => {
    props.close();
  };
  const issueCommand = async () => {
    const thunk = dispatch(issueCommandThunk({ uavId: selectedUavId }));
    setCommandRequest(thunk.requestId);
    try {
      await thunk.unwrap();
      close();
    } catch (err) {}
  };

  if (!selectedUavDirect || !command) return null;

  return (
    <Box
      sx={{ height: "100%", width: "100%" }}
      display="flex"
      justifyItems="center"
      flexDirection={"column"}
    >
      <Box
        display="flex"
        mt={1}
        sx={{ height: 60, width: "100%" }}
        justifyContent="end"
        alignItems={"center"}
      >
        <IconButton
          color="primary"
          aria-label="upload picture"
          component="span"
          sx={{
            width: 48,
            height: 48,
            border: 1,
            borderColor: "#D9DBE9",
            borderRadius: 2,
            margin: 1,
          }}
          onClick={close}
        >
          <Close stroke="#14142B" />
        </IconButton>
      </Box>
      <Box
        display="flex"
        mt={1}
        sx={{ height: 72, width: "100%" }}
        justifyItems={"center"}
        alignItems={"center"}
      >
        <Box display="flex" sx={{ width: 320 }} flexDirection={"row"} pl={8}>
          <Box display="flex" sx={{ width: 79 }}>
            <AircraftNub
              uavId={selectedUavDirect?.payload.uav_id || ""}
              flightMode={flightMode || ""}
              uavState={selectedUavDirect.payload.uav_state || ""}
            />
          </Box>
          <Box
            display="flex"
            sx={{ width: 79 }}
            justifyItems={"center"}
            alignItems={"center"}
          >
            <ForwardArrow stroke={"#14142B"} width={"100%"} />
          </Box>
          <Box display="flex" sx={{ width: 79 }}>
            <AircraftNub
              uavId={selectedUavDirect?.payload.uav_id || ""}
              flightMode={commandState[command].newFlightMode}
              uavState={commandState[command].newUavState}
            />
          </Box>
        </Box>
      </Box>
      <Box display="flex" mt={2} sx={{ height: 48, width: "100%" }}>
        <Typography
          variant={"h4"}
          sx={{ textAlign: "center", textJustify: "center", width: "100%" }}
          fontWeight={600}
          color={"#14142B"}
        >
          Are you sure?
        </Typography>
      </Box>
      <Box display="flex" mt={1} sx={{ height: 54, width: "100%" }} px={1}>
        <Typography
          color={"#4E4B66"}
          variant={"body2"}
          sx={{ textAlign: "center" }}
        >
          {commandState[command].description}
        </Typography>
      </Box>
      <Box
        display="flex"
        mt={1}
        sx={{ flexGrow: 1, width: "100%" }}
        justifyItems="center"
        alignItems="end"
      >
        <Button
          sx={{
            color: "inherit",
            textDecoration: "none",
            textTransform: "none",
            height: 76,
            width: "100%",
            backgroundColor: "#F7F7FC",
          }}
          onClick={issueCommand}
        >
          {commandRequestPending ? (
            <CircularProgress />
          ) : (
            <Typography>{commandState[command].action}</Typography>
          )}
        </Button>
      </Box>
    </Box>
  );
};
